import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { permissionDirective } from '@/directives'
import { useGlobalStore } from '@/stores/global-store'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { initializeI18n } from './i18n/i18n'
import InlineSvg from '@/components/InlineSvg.vue'
import InputTip from '@/components/InputTip.vue'
import TextTruncate from '@/components/TextTruncate.vue'
import DisplayMoney from '@/components/DisplayMoney.vue'
import { registerSW } from 'virtual:pwa-register'

async function bootstrapApp() {
  try {
    const app = createApp(App)

    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate)
    app.use(pinia)

    const globalStore = useGlobalStore()

    const i18nInstance = await initializeI18n()
    app.use(i18nInstance)

    const updateSW = registerSW({
      onNeedRefresh() {
        console.log('[SW] New version available')

        const confirmed = window.confirm(
          (i18nInstance.global.t as (key: string) => string)('MetabolicLang.common.NewVersionAvailable'),
        )

        if (confirmed) {
          updateSW(true)
        }
      },
      onOfflineReady() {
        console.log('[SW] Offline ready')
      },
    })

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('[SW] controllerchange')
        location.reload()
      })
    }

    app.use(router)

    if (import.meta.env.VITE_APP_GTM_ENABLED) {
      app.use(
        createGtm({
          id: import.meta.env.VITE_APP_GTM_KEY,
          debug: false,
          vueRouter: router,
        }),
      )
    }

    // Configure Vuestic with the saved theme settings
    const vuesticConfig = { ...vuesticGlobalConfig }
    vuesticConfig.colors.currentPresetName = globalStore.theme
    app.use(createVuestic({ config: vuesticConfig }))

    app.directive('permission', permissionDirective)

    app.component('InlineSvg', InlineSvg)
    app.component('InputTip', InputTip)
    app.component('TextTruncate', TextTruncate)
    app.component('DisplayMoney', DisplayMoney)

    app.mount('#app')
  } catch (error) {
    console.error('Failed to initialize i18n or bootstrap app:', error)
  }
}

bootstrapApp()
